// import "./styles.css";
import React, { useEffect } from "react";
export default function Img(props) {
    function onErrorEventHandler(e) {
        if (props.fallback) {
            e.target.src = props.fallback
        }
    }

    return (
        <div className="image_wrapper">
            <img
                {...props}
                onError={onErrorEventHandler}
            />
        </div>
    );
}